import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {PercentageSpentResolveComponent} from './percentage-spent-resolve.component';

@NgModule({
  declarations: [
    PercentageSpentResolveComponent
  ],
  exports: [
    PercentageSpentResolveComponent
  ],
  imports: [
    CommonModule
  ]
})
export class PercentageSpentResolveModule { }
